import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  deleteIngredient,
  getIngredients,
} from "../../redux/actions/ingredientsAction";
import { confirmDelete } from "../../utils/commonFunctions";

export default function Index() {
  const history = useHistory();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getIngredients(setLoading));
  }, [dispatch]);

  let { allIngredients } = useSelector((state) => state.ingredients);

  const [loading, setLoading] = useState(false);

  const [search, setSearch] = useState("");
  const getFilteredData = (data, search) => {
    if (search.length) {
      search = search.toLowerCase();
      data = data.filter((item) => item?.name?.toLowerCase().includes(search));
    }
    return data;
  };
  const onDelete = (id, position) => {
    confirmDelete(
      () => {
        dispatch(deleteIngredient(id));
      },
      "Do you want to delete this Ingredient?",
      position
    );
  };

  allIngredients = getFilteredData(allIngredients, search);
  return { allIngredients, loading, history, search, setSearch, onDelete };
}
